import React from "react"
import { graphql } from "gatsby"
import LinkList from "./LinkList"
import Teaser from "./Teaser"

// import * as styles from "./linklistteaser.module.scss"

const LinkListTeaser = ({ title, description, ctas, linkListItems }) => {
  const teaser = {title, description, ctas, theme: 'basic'}

  return (
    <>
      { teaser &&
      <Teaser {...teaser} >
        {linkListItems &&
        <LinkList theme='llTeaser' linkListItems={linkListItems} />
        }
      </Teaser>
      }
    </>
  )
}

export default LinkListTeaser

export const query = graphql`
  fragment LinkListTeaserData on STRAPI__COMPONENT_SUPERCUSTOM_LINK_LIST_TEASER {
    description {
      type
      children {
        text
        type
      }
    }
    ctas {
      label
      page {
        path
        title
      }
    }
    title {
      copy
      header
    }
    linkListItems {
      page {
        path
        title
      }
      label
      href
      text
      image {
        alternativeText
        localFile {
          childImageSharp {
            gatsbyImageData(width: 120 placeholder: BLURRED)
          }
        }
      }
    }
  }
`
